import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FaFolder, FaLock } from "react-icons/fa";
import { closeEmployeeFolder, fetchEmployeeFolder } from "../../../redux/slices/organizationDocumentsSlice";
import EmployeeDocumentsPanel from "../../documentLibrary/EmployeeDocumentsPanel";
import "../../documentLibrary/DocumentExplorer.css";

const DocumentsTab = ({ userId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { employeeFolders, employeeFolder, employeeAccessDenied } = useSelector((state) => state.organizationDocuments);

  if (employeeAccessDenied) {
    return <div className="py-5 text-center txt-subtle">{t("components.employeeProfile.documentsTab.noAccess")}</div>;
  }

  return (
    <div className="document-library document-library--embedded">
      <div className="document-workspace">
        <aside className="document-places" aria-label={t("pages.Documents.folders")}>
          <h2>{t("pages.Documents.folders")}</h2>
          <button className={!employeeFolder ? "active" : ""} onClick={() => dispatch(closeEmployeeFolder())}>
            <FaFolder /><span>{t("pages.Documents.allFiles")}</span><small>{employeeFolders.length}</small>
          </button>
          {employeeFolders.map((folder) => (
            <button
              key={folder.id}
              className={employeeFolder?.id === folder.id ? "active" : ""}
              onClick={() => dispatch(fetchEmployeeFolder({ userId, folderId: folder.id }))}
            >
              <FaFolder /><span>{folder.name}</span><small>{folder.document_count}</small>
            </button>
          ))}
          <div className="document-places-note"><FaLock /><p>{t("components.employeeProfile.documentsTab.accessNote")}</p></div>
        </aside>
        <EmployeeDocumentsPanel userId={userId} />
      </div>
    </div>
  );
};

export default DocumentsTab;
